module.exports = __webpack_public_path__ + "img/astronaut.86ac9050.svg";